import Styled from 'styled-components';

const InfoWraper = Styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .nav-author {
        width: 100%;
    }
`;

export { InfoWraper };
